import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loginKey: sessionStorage.getItem('loginKey') || '',
    showTopUpCount: 0, //显示登录弹窗版本
  }),
  actions: {
    setLoginKey(key: any) {
      this.loginKey = key;
      let count = this.showTopUpCount + 1;
      this.showTopUpCount = count;
      if( key == null ){
        key = '';
      }
      sessionStorage.setItem('loginKey', key);
    },
    setShowTopUpCount(showTopUpCount) {
      this.showTopUpCount = showTopUpCount;
    },
    removeLoginKey() {
      this.loginKey = null;
      let count = this.showTopUpCount + 1;
      this.showTopUpCount = count;
      sessionStorage.removeItem('loginKey');
    }
  }
});